import React, { useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useUser } from "../context/UserContext";
import { useNotify } from "../context/NotificationContext";
import { siteOnlyPathAllowed, showSiteOnlyNotice } from "../components/siteOnlyAccess";

import { useAuth } from "../context/AuthContext";
import type { AuthRole } from "../types/auth";

interface PrivateRouteProps {
  role?: AuthRole;
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({ role }) => {
  const { isAuthenticated, role: currentRole } = useAuth();
  const { user } = useUser();
  const { pathname } = useLocation();
  const notify = useNotify();
  const blocked = currentRole === "teacher" && user?.siteOnly && !siteOnlyPathAllowed(pathname);
  useEffect(() => { if (blocked) showSiteOnlyNotice(notify); }, [blocked, notify]);
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (role && currentRole !== role) {
    return <Navigate to={currentRole === "student" ? "/student/courses" : "/courses"} replace />;
  }
  if (blocked) return <Navigate to="/site-builder" replace />;
  return <Outlet />;
};

export default PrivateRoute;
